export enum TipoMensaje {
    success = "success",
    error = "error",
    warning = "warning",
    question = "question",
    info = "info"
  };